// tslint:disable:max-line-length

import * as React from "react";
import TranslateNew from "@translate/TranslateNew";
import { WithStyles, withStyles, IconButton} from "@material-ui/core";
import {CarouselStyle} from "./carousel.style";
import LeftIcon from "@material-ui/icons/ArrowBackIosRounded";
import RightIcon from "@material-ui/icons/ArrowForwardIosRounded";
import CloseIcon from '@material-ui/icons/CloseRounded';
import { primaryColor } from 'src/main.style';

const tn: TranslateNew = TranslateNew.getInstance();

interface ICarouselProps extends WithStyles<typeof CarouselStyle> {
  slides: JSX.Element[];
  close: () => void;
}

interface ICarouselState {
  currentSlide:string;
}


class Carousel extends React.Component<ICarouselProps, ICarouselState> {

  private containerRef: React.RefObject<HTMLDivElement> = React.createRef();
  private slideRefs: Array<React.RefObject<HTMLDivElement>>;
  private observer: IntersectionObserver;

  constructor(props: ICarouselProps) {
    super(props);

    const refs: Array<React.RefObject<HTMLDivElement>> = [];
    for (const slide of props.slides) {
      refs.push(React.createRef());
    }
    this.slideRefs = refs;

    this.state = {
      currentSlide:"slide0",
    }
  }

  public componentDidMount() {
    this.observe();
  }

  public render() {
    const {classes, close, slides} = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.top}>
          <IconButton onClick={() => close()} ><CloseIcon /></IconButton>
        </div>
        <div className={classes.slideContainer} ref={this.containerRef}>
          {slides.map((slide, index) =>  <div ref={this.slideRefs[index]} key={"slide"+index} id={"slide"+index} className={classes.slide}> 
              {slide}
            </div>)}
        </div>
        <div className={classes.bottom}>
          <IconButton onClick={() => this.slide("back")} ><LeftIcon /></IconButton>
          {slides.map((slide, index) => <div key={slide.key} className={classes.dot} 
            style={this.state.currentSlide === ("slide"+index)?{backgroundColor:primaryColor}:{}}/>)}
          <IconButton onClick={() => this.slide("forward")} ><RightIcon /></IconButton>
        </div>
      </div>
    );
  }


  public slide(direction:"forward"|"back") {
    let currentSlide:number  = 0;
    for (const slideRef of this.slideRefs) {
      if (slideRef.current) {
        if (slideRef.current.id === this.state.currentSlide) {
          break;
        }
      }
      currentSlide++;
    }
    if (direction === "forward" && currentSlide < this.slideRefs.length - 1 && this.slideRefs[currentSlide+1].current) {
      const wantedSlide = this.slideRefs[currentSlide+1].current;
      if (wantedSlide) {
        wantedSlide.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (direction === "back" && currentSlide > 0 && this.slideRefs[currentSlide-1].current) {
      const wantedSlide = this.slideRefs[currentSlide-1].current;
      if (wantedSlide) {
        wantedSlide.scrollIntoView({ behavior: 'smooth' });
      }
    } 
  }

  private observe() {
    const container = this.containerRef.current;

    if (container) {

      const options:IntersectionObserverInit = {
        root: container,
        rootMargin: "0px",
        threshold: 0.5,
      };

      const callback = (entries:IntersectionObserverEntry[], observer:IntersectionObserver) => {
        entries.forEach((entry:IntersectionObserverEntry) => {
          if (entry.isIntersecting) {
            const visibleChildId = entry.target.getAttribute('id');
            if (visibleChildId !== null) {              
              this.setState({currentSlide:visibleChildId});
            }
          }
        });
      };

      this.observer = new IntersectionObserver(callback, options);

      for (let index = 0; index < container.children.length; index++) {
        const element = container.children.item(index);
        if (element) {
          this.observer.observe(element);
        }
      }
    }
  }
}

export default withStyles(CarouselStyle)(Carousel);



// WEBPACK FOOTER //
// ./src/components/carousel/carousel.component.tsx